/**
 * @fileoverview Aside 等に表示される会員登録 CTA セクション
 */
<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import ButtonDefault from '@/components/button/ButtonDefault.vue'
import { newUserRegistrationPath } from '@/generated/railsRoutes'
import { pathWithQueryParams } from '@/utilities/path'

export default defineComponent({
  name: 'SignUpCta',

  components: {
    ButtonDefault,
  },

  props: {
    /**
     * CTA の文章部分のバリエーション
     */
    variant: {
      type: String as PropType<'a' | 'b'>,
      default: 'a',
    },

    /**
     * CTA ボタンに付与するクエリパラメータ
     */
    parameters: {
      type: Array as PropType<QueryParameter[]>,
      default: () => [],
    },
  },

  setup(props) {
    const heading = computed(() => {
      switch (props.variant) {
        case 'a':
          return '会員様しか読めない記事が<span class="span u-text__block">多数</span>'
        default:
          return 'クラウド活用と生産性向上なら<span class="span u-text__block">「BizHint」</span>'
      }
    })

    const ctaPath = computed(() => pathWithQueryParams(newUserRegistrationPath(), props.parameters))

    return {
      // computed
      heading,
      ctaPath,
    }
  },
})
</script>

<template>
  <section class="f-section__signUpCTA">
    <div class="f-section__signUpCTA--body">
      <div class="o-heading__signUpCTA">
        <h2
          class="o-heading__signUpCTA--item"
          v-html="heading" />
      <!-- /.o-heading__signUpCTA --></div>

      <template v-if="variant === 'a'">
        <div class="o-label__signUpCTA">
          <p class="o-label__signUpCTA--item">
            BizHintへ会員登録いただくと、全ての記事が無料でお読みいただけます。また、連載の更新情報やお役立ち資料を定期的にメールでお届け。ぜひご登録ください。
          </p>
        <!-- /.o-label__signUpCTA --></div>
      </template>
      <template v-else>
        <div class="o-list__signUpCTA">
          <ul class="o-list__signUpCTA--items">
            <li class="o-list__signUpCTA--item">
              <span class="o-list__signUpCTA--label">
                700以上の用語解説が読める
              </span>
            </li>
            <li class="o-list__signUpCTA--item">
              <span class="o-list__signUpCTA--label">
                様々な企業経営者の成功事例が知れる
              </span>
            </li>
            <li class="o-list__signUpCTA--item">
              <span class="o-list__signUpCTA--label">
                厳選記事やお役立ち資料がメールで届く
              </span>
            </li>
            <li class="o-list__signUpCTA--item">
              <span class="o-list__signUpCTA--label">
                アプリで効率的に情報収集も可能
              </span>
            </li>
          </ul>
        <!-- /.o-list__signUpCTA --></div>
      </template>

      <ButtonDefault
        :href="ctaPath"
        is-font-small
        has-shadow
        narrow-margin
        color="orange">
        {{ variant === 'a' ? '【無料】BizHintの会員になる' : '【無料】今すぐ会員登録する' }}
      </ButtonDefault>
    <!-- /.f-section__signUpCTA body --></div>
  <!-- /.f-section__signUpCTA --></section>
</template>

<style lang="sass" scoped>
// foundation
.f-section__signUpCTA
  border: 1px solid $border-x-light-gray
  background-color: rgba($bg-white, 1)

  $logo-width-origin: 300
  $logo-height-origin: 63
  $logo-height-render: 16
  $logo-width-render: imageScaleSize($logo-width-origin, $logo-height-origin, $logo-height-render, width)
  &::before
    content: ""
    width: #{$logo-width-render}px
    height: 1em
    display: block
    margin:
      top: 1em
      left: 1em
    background:
      image: url(@/images/logo-bizhint_01.svg)
      repeat: no-repeat
      position: center center
      size: contain

  & &--body
    padding: 1em

// object
.o-heading__signUpCTA
  margin-bottom: 0.5em

  &:last-child
    margin-bottom: 0

  & &--item
    line-height: 1.4
    font-size: $font-large

.o-label__signUpCTA
  & &--item
    line-height: 1.6
    font-size: $font-small

.o-list__signUpCTA
  $root: &

  & &--item
    display: grid
    grid-template-columns: auto 1fr
    column-gap: 0.5em
    margin-top: 0.3em

    &:first-child
      margin-top: 0

    &::before
      content: ""
      width: 0.55em
      height: 0.25em
      display: block
      transform: rotate(-45deg)
      position: relative
      top: 0.4em
      border:
        left: 0.1em solid $border-orange
        bottom: 0.1em solid $border-orange

  & &--label
    font-size: $font-small
</style>
